import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Page from 'components/page/page.component';

const BuildingBlocks = () => {
    return (
        <Page heroTitle="Building Blocks" heroSize="small">
            <Container>
                <Row>
                    <Col xs="12">
                        <p>
                            BuildingBlocks is an application provided to the City of Muncie by Boston-based Tolemi to
                            display and analyze public sources of property records. The software is web-based, and can
                            be viewed at{' '}
                            <a href="https://muncie-in.tolemi.com/" target="window">
                                https://muncie-in.tolemi.com/
                            </a>
                        </p>
                    </Col>
                </Row>
            </Container>
        </Page>
    );
};

export default BuildingBlocks;
